<template>
  <div class="media-course">
    <div v-if="initLoad">
      <FirstCourse
        v-if="courseDetail.mediaLevel == 1"
        :courseData="courseDetail"
        :onclick="handleCourseItem"
      />
    </div>
  </div>
</template>

<script>
import api from "@edu-fe/api";
import queryString from "@/utils/queryString";
import FirstCourse from "./components/FirstCourse";
import module from "../../modules/mediaCourse";
import { mapState, mapMutations } from "vuex";
import keys from "lodash.keys";
export default {
  data() {
    return {
      initLoad: false,
      courseDetail: "",
    };
  },

  computed: {
    ...mapState(module.name, keys(module.state)),
  },
  

  mounted() {
    this.init();
  },

  methods: {
    ...mapMutations(module.name, keys(module.mutations)),
    async init() {
      this.$loading.show()
      let params = {
        orgMediaInfoId: queryString().orgMediaInfoId,
      };
      const { data } = await api.mediaCourse.getCourseDetail(params)();
      this.$loading.hide()
      if (data) {
        let result = [];
        if (data.mediaLevel == 1) {
          result = data.subCourses
        }
        if (data.mediaLevel == 2 || result.length == 0) {
          return this.$toast.show({
            message: "暂无数据",
          });
        }
        this.initLoad = true;
        this.courseDetail = data;
        this.saveCourseDetail(data);
      } else {
        this.$toast.show({
          message: "暂无数据",
        });
      }
    },

    handleCourseItem(item, index) {
      console.log(item,123)
      if (item.audioType === 3 && item.outLink !== '') {
        window.location.href = item.outLink
        return
      }
      let temResult = {
        index,
        ...item.mediaItemList,
      };
      this.$router.push(`/media-course-detail?chapterId=${item.id}&courseIndex=${index}&orgMediaInfoId=${queryString().orgMediaInfoId}`);
    },
  },

  components: {
    FirstCourse,
  },
};
</script>

<style lang="scss" scoped>
</style>